<div
  class="jp-user-bet__wrapper"
  [style.border-color]="bet().user_color"
  [class.end]="isEnd()"
  [class.winner]="isEnd() && isWinner()"
>
  <app-player-row
    class="jp-user-bet__player"
    (click)="
      contextMenuService.open($event, {
        user: bet()
      })
    "
    [player]="bet()"
    [rowSettings]="{
      avatar: {
        borderColor: bet().user_color,
        filter: 'drop-shadow(0px 0px 12px ' + bet().user_color + 66 + ')',
      }
    }"
  ></app-player-row>
  <div class="jp-user-bet__chance">
    Win Chance: <span> {{ bet().chances | number : "1.2-2" }}% </span>
  </div>
  <div class="jp-user-bet__bet">
    Bet:
    <app-cost
      [cost]="bet().total_value"
      [gap]="4"
      color="var(--yellow)"
      [balanceType]="'skins'"
    />
  </div>
</div>
